import { DeletionConfirmationPopup } from './deletionConfirmation.popup.tsx';

export const deletionConfirmationPopup = new DeletionConfirmationPopup();
